import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Output } from '@angular/core';
import {
  AdministrationResultStatus,
  PaginationArgs,
  ServiceCategoryData,
  ServiceTypeData
} from "../../../clients/system-api/SystemApiClient";
import { ServiceCategoryService } from "../../../services/service-category.service";
import { ServiceTypeService } from "../../../services/service-type.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { SnackBarService } from "../../../services/snack-bar.service";
import { WindowDimensions, WindowDimensionsService } from 'src/app/services/window-dimension-service.service';

@Component({
  selector: 'app-service-category-popup',
  templateUrl: './service-category-popup.component.html',
  styleUrls: ['./service-category-popup.component.scss']
})
export class ServiceCategoryPopupComponent implements OnInit {

  @Output() close = new EventEmitter<boolean>();
  @Input() serviceCategoryId!: number
  serviceCategoryData!: ServiceCategoryData
  serviceTypes!: ServiceTypeData[]
  serviceCategoryForm: FormGroup = new FormGroup({})
  showError: boolean = false;
  imageName: string = ''; 

  windowDimensions: WindowDimensions = {} as WindowDimensions;

  constructor(
    private serviceCategoryService: ServiceCategoryService,
    private serviceTypeService: ServiceTypeService,
    private formBuilder: FormBuilder,
    private _snackBarService: SnackBarService,
    private _windowDimensionService: WindowDimensionsService) {

    this._windowDimensionService.getWindowDimensions$().subscribe((dimensions) => {
      this.windowDimensions = dimensions;
    });

    if (this.serviceCategoryId != undefined)

      this.serviceCategoryForm = this.formBuilder.group({
        name: new FormControl('', [Validators.required]),
        serviceTypeId: new FormControl(0, [Validators.required, Validators.min(1)]),
        active: new FormControl(true, [Validators.required]),
        requiresMembership: new FormControl(0, [Validators.required]),
        image: new FormControl('')
      })
  }

  ngOnInit(): void {
    this.serviceCategoryForm = this.formBuilder.group({
      name: new FormControl('', [Validators.required]),
      serviceTypeId: new FormControl(0, [Validators.required, Validators.min(1)]),
      active: new FormControl(true, [Validators.required]),
      requiresMembership: new FormControl(0, [Validators.required]),
      image: new FormControl('')
    });

    if (this.serviceCategoryId != undefined)
      this.serviceCategoryService.retriveServiceCategoryById(this.serviceCategoryId).subscribe(result => {
        this.serviceCategoryData = result.content!
        this.serviceCategoryForm.get('name')?.setValue(this.serviceCategoryData.name);
        this.serviceCategoryForm.get('serviceTypeId')?.setValue(this.serviceCategoryData.serviceTypeId);
        this.serviceCategoryForm.get('active')?.setValue(this.serviceCategoryData.active);
        this.serviceCategoryForm.get('requiresMembership')?.setValue(this.serviceCategoryData.requiresMembership ? 1 : 0);
        this.serviceCategoryForm.get('image')?.setValue(this.serviceCategoryData.image)
      })

    this.serviceTypeService.retrieveAllServiceTypes({} as PaginationArgs).subscribe(result => {
      if (result.status == AdministrationResultStatus.Success)
        this.serviceTypes = result.content?.items!
    })
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.imageName = file.name

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.serviceCategoryForm.get('image')?.setValue(reader.result!.toString().split(',')[1]);
      };
    }
  }

  submit() {
    let serviceCategoryData = {
      name: this.serviceCategoryForm.get('name')?.value,
      serviceTypeId: this.serviceCategoryForm.get('serviceTypeId')?.value,
      requiresMembership: this.serviceCategoryForm.get('requiresMembership')?.value == 1,
      active: this.serviceCategoryForm.get('active')?.value,
      image: this.serviceCategoryForm.get('image')?.value
    } as ServiceCategoryData

    if (this.serviceCategoryId != undefined && this.serviceCategoryId != undefined)
      serviceCategoryData.id = this.serviceCategoryId;

    this.serviceCategoryId == undefined ? this.serviceCategoryService.addServiceCategory(serviceCategoryData).subscribe(result => {

      if (result == AdministrationResultStatus.Success || result == AdministrationResultStatus.ServerError) {
        this._snackBarService.callSnackBar(result, result == AdministrationResultStatus.Success ? "ServiceCategoryAddSuccess" : "ServiceCategoryAddFail")
        this.closePopup();
      } else if (result == AdministrationResultStatus.RecordAlreadyExists) {
        this.showError = true
      }
    }) : this.serviceCategoryService.editServiceCategory(serviceCategoryData).subscribe(result => {

      if (result == AdministrationResultStatus.Success || result == AdministrationResultStatus.ServerError) {
        this._snackBarService.callSnackBar(result, result == AdministrationResultStatus.Success ? "ServiceCategoryEditSuccess" : "ServiceCategoryEditFail")
        this.closePopup();
      } else if (result == AdministrationResultStatus.RecordAlreadyExists) {
        this.showError = true
      }
    })
  }

  closePopup() {
    this.close.emit();
  }

}
